import React, { useEffect, useState } from 'react';

type TabsProp = {
  tabTitles: string[];
  setTabTitles?: (titles: string[]) => void | undefined;
  activeTab: number;
  setActiveTab: (value: number) => void;
  addClose?: boolean;
  onClose?: (index: number) => void;
  disableInactiveTabs?: boolean;
  className?: string;
  tabClassName?: string;
  activeTabClassName?: string;
  inactiveTabClassName?: string;
};

export const Tabs = ({
  tabTitles,
  setTabTitles,
  activeTab,
  setActiveTab,
  addClose = false,
  onClose,
  disableInactiveTabs = false,
  className,
  tabClassName,
  activeTabClassName,
  inactiveTabClassName,
}: TabsProp) => {
  const [visitedTabs, setVisitedTabs] = useState<number[]>([activeTab]);

  useEffect(() => {
    if (!visitedTabs.includes(activeTab)) {
      setVisitedTabs((prev) => [...prev, activeTab]);
    }
  }, [activeTab, visitedTabs]);

  const handleRemoveTab = (index: number) => {
    if (onClose) {
      onClose(index);
    } else if (setTabTitles !== undefined) {
      const newTabs = tabTitles.filter((_, i) => i !== index);
      setTabTitles(newTabs);
    }
  };

  return (
    <div
        className={`w-full overflow-x-auto p-1 bg-slate-100/80 backdrop-blur-sm rounded-xl border border-slate-200/50 sm:inline-flex sm:w-auto ${className}`}
    >
      <div className='flex min-w-max gap-1'>
        { tabTitles.map((item: string, index: number) => {
          const isActive = activeTab === index;
          const isDisabled =
            disableInactiveTabs && !visitedTabs.includes(index);

          return (
            <button
                key={item + index}
                type='button'
                className={`
             min-h-9 whitespace-nowrap px-3 py-2 text-[12px] font-semibold rounded-lg transition-all flex duration-300 ease-[cubic-bezier(0.4,0,0.2,1)] sm:min-h-0 sm:px-2 sm:py-1
                ${tabClassName}
                ${
                  isActive
                    ? `bg-white text-emerald-600 shadow-sm ring-1 ring-black/5 scale-[1.02] ${activeTabClassName}`
                    : `text-slate-500 hover:text-slate-700 hover:bg-white/40 ${inactiveTabClassName}`
                }
              ${isDisabled ? 'pointer-events-none opacity-50' : ''}
            `}
                onClick={() => !isDisabled && setActiveTab(index)}
                disabled={isDisabled}
            >
              <span>{ item }</span>
              { addClose && setTabTitles && index > 1 && item !== 'CCA Results' && (
                <span
                    className='ml-2 text-gray-400 hover:text-red-500 cursor-pointer'
                    onClick={(e) => {
                      e.stopPropagation();
                      handleRemoveTab(index);
                    }}
                    tabIndex={-1}
                    aria-label='Close Tab'
                >
                  <svg
                      className='w-4 h-4'
                      fill='none'
                      stroke='currentColor'
                      viewBox='0 0 24 24'
                  >
                    <path
                        strokeLinecap='round'
                        strokeLinejoin='round'
                        strokeWidth={2}
                        d='M6 18L18 6M6 6l12 12'
                    />
                  </svg>
                </span>
              ) }
            </button>
          );
        }) }
      </div>
    </div>
  );
};
